import FlowEdge from "./edges/FlowEdge";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import "reactflow/dist/style.css";
import ReactFlow, { Background, Controls, ReactFlowProvider } from "reactflow";
import StartNode from "./nodes/StartNode";
import { useEffect, useLayoutEffect, useState } from "react";
import TrailNode from "./nodes/TrailNode";
import TrailEdge from "./edges/TrailEdge";
import { handleLayout } from "./layouter";
import { Badge, Button, Flex } from "@mantine/core";
import NodeActionPanel from "./panel/NodeActionPanel";
import BaseNode from "./nodes/BaseNode";
import "./flowStyles.scss";
import WorkflowSaver from "./panel/WorkflowSaver";
import { useParams } from "react-router-dom";
import WorkflowListingModal from "../../listing/WorkflowListingModal";
import { useUIStore } from "../../../../../stores/UIStore";
import PopupNew from "./PopupNew";
import { useProfileStore, useSessionStore } from "../../../../../stores/UserStore";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { updateProfile, updateSelf } from "../../../../../api/UserAPI";

const edgeTypes = {
  main: FlowEdge,
  trail: TrailEdge,
};

const nodeTypes = {
  start: StartNode,
  trail: TrailNode,
  action: BaseNode,
};

const Flow = ({ setShouldWarn, setFlowInstance }) => {
  const lang = useLanguage((s) => s.language);
  const nodes = useFlowStore((s) => s.nodes);
  const edges = useFlowStore((s) => s.edges);
  const loadingPage = useFlowStore((s) => s.loadingPage);
  const headerClosed = useUIStore((s) => s.headerClosed);
  const { workflowId, campaignId } = useParams();

  const handleNodesChange = (change) => {
    setShouldWarn?.(true);
  };

  const handleNodeClick = (e, node) => {
    setShouldWarn?.(true);
    return false;
  };

  useLayoutEffect(() => {
    handleLayout();
  }, [workflowId]);

  const handleSwitch = () => {
    let switched = !!useSessionStore.getState().user_switch;
    if (!switched) {
      updateProfile(null, { show_new_workflow_builder: true }).then(() =>
        updateSelf(),
      );
    }

    useFlowStore.getState().setLayout("horizontal");
  };

  return (
    <Flex
      h={"100%"}
      mih={headerClosed ? "calc(100vh - 68px)" : "calc(100vh - 124px)"}
      style={{ overflow: "hidden" }}
      pt={12}
    >
      <ReactFlowProvider>
        <ReactFlow
          id="workflow"
          nodes={nodes}
          nodeTypes={nodeTypes}
          edges={edges}
          onNodesChange={handleNodesChange}
          onInit={setFlowInstance}
          connectOnClick={false}
          panOnScroll
          panOnScrollMode="vertical"
          panOnDrag={true}
          zoomOnScroll={false}
          preventScrolling
          // fitView
          defaultEdgeOptions={{
            type: "main",
            deletable: false,
            focusable: false,
            updatable: false,
          }}
          edgeTypes={edgeTypes}
          disableKeyboardA11y
          nodesDraggable={false}
          proOptions={{
            hideAttribution: true,
          }}
          defaultViewport={
            useFlowStore.getState().layout === "horizontal"
              ? undefined
              : {
                  x:
                    useFlowStore.getState().selectedNode && nodes.length > 2
                      ? window.innerWidth / 2 - 512
                      : window.innerWidth / 2 - 256,
                  y: useFlowStore.getState().selectedNode
                    ? useFlowStore.getState().selectedNode?.y + 132
                    : -32,
                  zoom: 1,
                }
          }
          translateExtent={
            useFlowStore.getState().layout === "horizontal"
              ? undefined
              : [
                  [-Infinity, 32],
                  [Infinity, Infinity],
                ]
          }
          nodeExtent={
            useFlowStore.getState().layout === "horizontal"
              ? undefined
              : [
                  [-Infinity, 32],
                  [Infinity, Infinity],
                ]
          }
          maxZoom={1}
          edgesUpdatable={false}
          edgesFocusable={false}
          onNodeClick={handleNodeClick}
        >
          <Background />
          <Controls position="bottom-right" showInteractive={false} />

          {nodes.length < 3 &&
            !loadingPage &&
            useProfileStore?.getState().profile.show_new_workflow_builder ===
              null && <PopupNew />}

          <Button
            variant="outline"
            bg={"#fff"}
            pos={"absolute"}
            top={16}
            right={32}
            style={{ zIndex: 600 }}
            size="md"
            leftSection={
              <Badge color="#ffd6d6" c={"black"}>
                Bêta
              </Badge>
            }
            radius={"lg"}
            onClick={handleSwitch}
          >
            {lang.campaign.popup_new.btn_test_new}
          </Button>
        </ReactFlow>

        <NodeActionPanel />
      </ReactFlowProvider>

      <WorkflowSaver />

      {!campaignId && <WorkflowListingModal />}
    </Flex>
  );
};

export default Flow;
